import request from '@/utils/request'

export function product () {
  return request({
    url: 'api/product',
    method: 'get'
  })
}

export function productHome () {
  return request({
    url: 'api/product/home',
    method: 'get'
  })
}

export function addProduct (formData) {
  return request({
    url: 'api/product/',
    method: 'post',
    data: formData
  })
}

export function editProduct (formData) {
  return request({
    url: 'api/product/',
    method: 'put',
    data: formData
  })
}

export function deleteProduct (uuid) {
  return request({
    url: 'api/product/' + uuid,
    method: 'delete'
  })
}

export function productDetail (id) {
  return request({
    url: 'api/product/' + id,
    method: 'get'
  })
}
